<script setup lang="ts">

</script>

<template>
	<div class="absolute right-0 -bottom-40">
		<div class="absolute -right-50 bottom-175 z-0">
			<div class="relative">
				<svg width="490" height="509" viewBox="0 0 490 509" fill="none" xmlns="http://www.w3.org/2000/svg" class="scale-150">
					<path d="M26.4002 343.035C-11.0928 383.366 -8.31709 446.021 32.5994 482.978C73.5159 519.934 137.079 517.198 174.573 476.867L463.599 165.964C501.093 125.634 498.317 62.9802 457.401 26.0224C416.484 -10.934 352.92 -8.19808 315.427 32.1329L26.4002 343.035Z" fill="#F7A600"/>
				</svg>
			</div>
		</div>
		<div class="absolute right-20 bottom-36 z-10">
			<svg width="532" height="547" viewBox="0 0 532 547" fill="none" xmlns="http://www.w3.org/2000/svg" class="scale-140">
				<path d="M30.4478 367.949C-9.95263 410.975 -6.96266 477.814 37.1277 517.239C81.2167 556.665 149.711 553.745 190.111 510.721L501.552 179.05C541.953 136.026 538.963 69.1868 494.872 29.7607C450.782 -9.66399 382.289 -6.7462 341.889 36.2794L30.4478 367.949Z" stroke="#151515" stroke-width="1"/>
			</svg>
		</div>
		<div class="absolute -right-50 bottom-60 z-30">
			<div class="relative">
				<svg width="483" height="496" viewBox="0 0 483 496" fill="none" xmlns="http://www.w3.org/2000/svg" class="scale-150">
					<path d="M24.3199 345.21C-10.2187 381.853 -7.66172 438.779 30.0306 472.357C67.723 505.934 126.277 503.448 160.817 466.805L458.68 150.791C493.219 114.147 490.662 57.221 452.969 23.6436C415.277 -9.93382 356.723 -7.44938 322.183 29.1954L24.3199 345.21Z" fill="#857E79"/>
				</svg>
			</div>
		</div>
		<div class="absolute -right-140 bottom-80 z-40">
			<svg width="532" height="548" viewBox="0 0 532 548" fill="none" xmlns="http://www.w3.org/2000/svg" class="scale-150">
				<path d="M30.4478 368.623C-9.95263 411.728 -6.96266 478.69 37.1277 518.187C81.2167 557.686 149.711 554.762 190.111 511.658L501.552 179.376C541.953 136.273 538.963 69.3106 494.872 29.8119C450.782 -9.68547 382.289 -6.76231 341.889 36.3425L30.4478 368.623Z" stroke="#F7A600" stroke-width="1"/>
			</svg>
		</div>
		<div class="absolute -right-50 -bottom-45 z-20">
			<div class="relative">
				<svg width="449" height="465" viewBox="0 0 449 465" fill="none" xmlns="http://www.w3.org/2000/svg" class="scale-150">
					<path d="M24.1912 313.382C-10.1646 350.227 -7.62117 407.465 29.8717 441.227C67.3645 474.989 125.609 472.489 159.966 435.645L424.808 151.618C459.165 114.773 456.621 57.5359 419.128 23.7729C381.636 -9.98881 323.39 -7.4894 289.034 29.3552L24.1912 313.382Z" fill="#DFDFD9"/>
				</svg>
			</div>
		</div>
	</div>
</template>
